import Api from './api';

const FuncionarioService = {
    login: async (params) => {
        const response = await Api.post('/funcionarios/login', params);
        localStorage.setItem('funcionario', JSON.stringify(response.data.Funcionario));
        localStorage.setItem('nome', response.data.Funcionario["nome"]);
        localStorage.setItem('token', response.data.token);
    },
    logout: () => {
        localStorage.removeItem('funcionario', null)
        localStorage.removeItem('token', null)
        localStorage.removeItem('nome', null)
    },
    cadastro: async (params) => {
        const response = await Api.post('/funcionarios/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    cadastroMultiplo: async (params) => {
        const response = await Api.post('/funcionarios/cadastrar-multiplos', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/funcionarios/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/funcionarios/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    deletar: (id) => {
        Api.delete(`/funcionarios/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    funcEdit: async (id) => {
        const response = await Api.get(`/funcionarios/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    senha: async (id, params) => {
        const response = await Api.put(`/funcionarios/senha/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/funcionarios/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    holerites: async (id) => {
        const response = await Api({
            method: 'get',
            url: `/holeritefuncionarios/holerites?id=${id}`,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    downloadHolerite: async (funcId, holeriteId) => {
        const response = await Api.get(
            `/holeritefuncionarios/download/${funcId}/${holeriteId}`,
            {
                headers: { 'x-access-token': localStorage.getItem('token') },
                responseType: "json"
            }
        );
        return response.data;
    },

    buscarHolerites: async (params) => {
        const response = await Api.get('/holeritefuncionarios/buscar',
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
}

export default FuncionarioService;
